import type { BlogPost } from "./blog";

export const BLOG_RESTAURANTS_PART4: BlogPost[] = [
  {
    "slug": "restorany-sadovaya-ulitsa-spb",
    "title": "Рестораны у Садовой улицы в Петербурге",
    "metaTitle": "Рестораны у Садовой улицы СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны рядом с Садовой улицей в Санкт-Петербурге: где поесть, обзор мест по кухне и цене.",
    "keywords": "рестораны садовая улица спб, рестораны у садовой петербург, кафе садовая спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Садовая улица — одна из главных магистралей исторического центра. Она проходит мимо Сенной площади, Юсуповского дворца и выходит к Марсову полю. По пути — масса ресторанов разных форматов.",
    "sections": [
      {
        "heading": "Ресторанные кластеры у Садовой",
        "body": "Садовая длинная — несколько километров. Самая насыщенная ресторанами часть: от Сенной площади до Невского проспекта. Сенная и её окрестности — демократичный сегмент. Ближе к Фонтанке — более камерные кафе. У Невского — туристический сегмент. Лучшие варианты — в переулках параллельно Садовой.",
        "list": [
          "У Сенной: демократичный сегмент",
          "Между Сенной и Невским: разнообразный выбор",
          "Переулки параллельно Садовой: лучшие места для местных",
          "Улица Марата — параллельна Садовой — лучший ресторанный квартал"
        ]
      },
      {
        "heading": "Лучшая альтернатива в 5 минутах",
        "body": "Улица Марата — параллельна Садовой, в 5 минутах пешком. На ней же находится «Паруса на крыше» (дом 5, Olympic Plaza, 6 этаж) — лучший панорамный ресторан этой части города. Рейтинг 5,0, 2 606 отзывов, бизнес-ланч от 590 ₽. Если вы ищете место у Садовой — Марата даст лучший выбор."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-v-istoricheskom-tsentre-peterburga",
    "title": "Рестораны в историческом центре Петербурга: обзор",
    "metaTitle": "Рестораны в историческом центре Петербурга 2026 | Паруса",
    "metaDescription": "Лучшие рестораны исторического центра Санкт-Петербурга: обзор по кухне, цене и атмосфере.",
    "keywords": "рестораны исторический центр петербург, рестораны центральный район спб, рестораны в историческом центре",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Исторический центр Петербурга — Центральный, Адмиралтейский и часть Петроградского районов — это место, где ресторан сам по себе является историческим событием. Здесь каждое здание помнит XIX век.",
    "sections": [
      {
        "heading": "Что особенного у ресторанов в историческом центре",
        "body": "Интерьер: высокие потолки, лепнина, паркет — в исторических зданиях атмосфера создаётся архитектурой, а не декораторами. Вид: из окон исторических домов — дворы-колодцы, купола, набережные. Контекст: когда ты ешь там, где Пушкин гулял — это создаёт особое ощущение.",
        "list": [
          "Архитектура: высокие потолки, лепнина, паркет",
          "Вид: дворы-колодцы, купола, набережные",
          "Исторический контекст: неотделим от места",
          "Цены: выше среднего — за атмосферу и локацию"
        ]
      },
      {
        "heading": "«Паруса» как вершина исторического центра",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) — уникальный формат: ресторан в центре, который дает вид на исторический центр сверху. 300° панорама. Казанский собор, крыши XIX века, горизонт. Это не просто хороший ресторан — это точка обзора всего исторического центра. Рейтинг 5,0, «Хорошее место 2026»."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-smolnyy-sobor-spb",
    "title": "Рестораны у Смольного собора в Петербурге",
    "metaTitle": "Рестораны у Смольного собора СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны рядом со Смольным собором в Петербурге: где поесть после экскурсии, обзор мест.",
    "keywords": "рестораны у смольного собора, рестораны смольный петербург, где поесть у смольного спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Смольный собор — шедевр Растрелли на правом берегу Невы. Голубые купола с белыми деталями — один из красивейших видов Петербурга. После посещения собора — куда поесть?",
    "sections": [
      {
        "heading": "Рестораны у Смольного",
        "body": "Район Смольного — тихий, жилой, не туристический. Ресторанов здесь немного. Ближайший ресторанный кластер — в районе Суворовского проспекта и Старорусской улицы. Для хорошего ужина с панорамой — лучше потратить 15–20 минут и добраться до центра.",
        "list": [
          "У Смольного: немного ресторанов",
          "Суворовский проспект: есть варианты для обеда",
          "15 минут до центра: лучший ресторанный выбор",
          "«Паруса»: с видом на сам Смольный — 20 минут на такси"
        ]
      },
      {
        "heading": "Вид на Смольный из ресторана",
        "body": "Смольный собор виден с правого берега Невы, с Литейного и Охтинского мостов. С высоты же — виден в панораме вместе с куполами центра. «Паруса на крыше» (ул. Марата, 5, 6 этаж) открывают широкий вид на Петербург, включая восточный силуэт с Смольным на горизонте. Рейтинг 5,0. Читайте о <a href='/blog/kupola-peterburg-gde-smotret' class='underline text-accent'>лучших видах на купола</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-pasta-peterburg",
    "title": "Рестораны с пастой в Петербурге: лучшие места",
    "metaTitle": "Рестораны с пастой в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны с пастой в Санкт-Петербурге: итальянская паста, авторские вариации, лучшие места.",
    "keywords": "рестораны с пастой петербург, паста ресторан спб, итальянская паста ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Паста — самое популярное итальянское блюдо в Петербурге. Но качество пасты в разных ресторанах отличается принципиально. Разберём, что искать.",
    "sections": [
      {
        "heading": "Паста ручной работы vs из пачки",
        "body": "Разница принципиальная. Паста ручной работы (fresca): мука + яйца, раскатывается и нарезается в ресторане. Мягче, нежнее, более пористая — лучше держит соус. Паста из пачки (secca): промышленного производства. Имеет право на существование, но в дорогом ресторане — признак экономии. Как узнать: спросите официанта. Если ответ «свежая» — хороший знак.",
        "list": [
          "Fresca (свежая): ручная работа, готовится в ресторане",
          "Secca (сухая): из пачки, допустимо в бюджетных местах",
          "Паста al dente: правильно приготовленная — с «хрустинкой»",
          "Соус: должен покрывать пасту, а не плавать рядом"
        ]
      },
      {
        "heading": "Паста в «Парусах»",
        "body": "В меню «Парусов» (ул. Марата, 5) присутствуют авторские блюда с пастой как часть итальянски-ориентированного раздела. Акцент — на качестве ингредиентов и авторской подаче. Морепродукты с пастой, ризотто — часть сезонного меню. Рейтинг 5,0. Читайте о <a href='/menu' class='underline text-accent'>меню ресторана</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "restorany-avtorskie-deserty-spb",
    "title": "Рестораны с авторскими десертами в СПб",
    "metaTitle": "Рестораны с авторскими десертами СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с авторскими десертами в Санкт-Петербурге: где готовят действительно интересные сладкие блюда.",
    "keywords": "рестораны авторские десерты спб, лучшие десерты ресторан петербург, десерт авторский спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Авторский десерт — финальный аккорд ужина и показатель кухонной культуры. Несколько петербургских ресторанов действительно вкладывают в десерты столько же таланта, сколько и в горячие блюда.",
    "sections": [
      {
        "heading": "Что делает десерт авторским",
        "body": "Не «тирамису из пакета» и не «мороженое Пломбир». Авторский десерт: несколько текстур (хруст, крем, мусс), баланс сладкого и кислого, сезонные ингредиенты, авторская подача (не просто «в вазочке»). Хороший десерт не повторяет другие блюда — это самостоятельное высказывание шефа-кондитера.",
        "list": [
          "Несколько текстур: хруст + нежность + жидкость",
          "Баланс: не просто «сладко», а сложный вкус",
          "Сезонность: летом — ягоды, осенью — яблоки",
          "Подача: как произведение — форма и цвет важны"
        ]
      },
      {
        "heading": "Десерты в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5) предлагают авторские десерты как часть обновляющегося меню. Это не стандартный набор из 5 позиций, а тщательно подобранный финал трапезы. Рейтинг 5,0. Спрашивайте «десерт дня» у официанта — в хорошем ресторане он всегда есть. Читайте о <a href='/blog/kak-vybrat-desert-v-restorane' class='underline text-accent'>выборе десерта</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню десертов", "href": "/menu" }
  },
  {
    "slug": "restorany-shirokiy-vybor-vin-spb",
    "title": "Рестораны с широким выбором вин в СПб",
    "metaTitle": "Рестораны с широким выбором вин СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с большой винной картой в Санкт-Петербурге: где найти хороший выбор вин по бокалам и бутылках.",
    "keywords": "рестораны широкий выбор вин спб, винная карта ресторан петербург, вино ресторан большой выбор спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Хорошая винная карта — признак ресторана, который серьёзно относится к гастрономии. Разберём, как читать винную карту и где найти достойный выбор в Петербурге.",
    "sections": [
      {
        "heading": "Что такое хорошая винная карта",
        "body": "Широта: разные регионы (Франция, Италия, Испания, Новый свет, Россия). Глубина: не только одно-два вина на цвет, а несколько вариантов по стилю. Вина по бокалам: важная опция — не всегда нужна бутылка. Ценовой диапазон: от доступного (1 500–2 000 ₽/бутылка) до премиального. Ротация: карта обновляется — значит сомелье работает активно.",
        "list": [
          "Разные регионы: не только одна страна",
          "Вина по бокалам: гибкость для гостей",
          "Ценовой диапазон: для разных бюджетов",
          "Сезонность: лёгкие белые летом, плотные красные зимой"
        ]
      },
      {
        "heading": "Вина в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5) предлагают широкую винную карту с вариантами по бокалам. Персонал готов рекомендовать вино под блюдо и бюджет. Рейтинг 5,0. Читайте о <a href='/blog/vino-restoran-spb-rekomendatsii' class='underline text-accent'>вине в ресторанах СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-legkaya-kukhnya-peterburg",
    "title": "Рестораны с лёгкой кухней в Петербурге",
    "metaTitle": "Рестораны с лёгкой кухней Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с лёгкой кухней в Санкт-Петербурге: средиземноморская, морепродукты, свежие блюда.",
    "keywords": "рестораны лёгкая кухня петербург, рестораны здоровое питание спб, лёгкие блюда ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "«Лёгкая кухня» — это не диетическая еда. Это кухня без тяжёлых соусов, с акцентом на свежесть продукта: рыба, морепродукты, овощи, свежие салаты, качественные масла. Средиземноморская традиция в петербургском ресторане.",
    "sections": [
      {
        "heading": "Что такое лёгкая кухня в ресторанном понимании",
        "body": "Лёгкая кухня: акцент на натуральный вкус продукта, минимальная термическая обработка (сашими, карпаччо, севиче), лёгкие соусы (винегрет, лимонный, оливковый), морепродукты и рыба как основа. Это альтернатива тяжёлой французской классике (густые сливочные соусы, жирное мясо). Летом и после тренировки — именно то, что нужно.",
        "list": [
          "Карпаччо, севиче: сырые продукты в кислотном маринаде",
          "Морепродукты на гриле: натуральный вкус без соусов",
          "Свежие салаты: не «салат Цезарь» как основное",
          "Лёгкие масляные/лимонные заправки"
        ]
      },
      {
        "heading": "Лёгкая кухня в «Парусах»",
        "body": "В меню «Парусов» (ул. Марата, 5) присутствуют лёгкие блюда: карпаччо, морепродукты, рыбные блюда с лёгкими соусами. Сезонное меню учитывает летний запрос на свежесть. Рейтинг 5,0. Для ужина после активного дня в городе — идеальный выбор. Читайте о <a href='/menu' class='underline text-accent'>полном меню</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "restorany-zhivoy-ogon-peterburg",
    "title": "Рестораны с живым огнём в Петербурге",
    "metaTitle": "Рестораны с живым огнём Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с открытым огнём в Санкт-Петербурге: хоспер, дровяная печь, мангал. Где готовят на огне.",
    "keywords": "рестораны живой огонь петербург, рестораны хоспер мангал спб, ресторан открытый огонь петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Живой огонь в кулинарии — самая древняя технология и самая современная тенденция. Хоспер, дровяная печь, открытый мангал — продукты, приготовленные на огне, имеют особый вкус.",
    "sections": [
      {
        "heading": "Форматы живого огня в ресторанах",
        "body": "Хоспер: испанский угольный гриль — закрытый, с точным контролем температуры. Даёт дымный аромат и карамелизированную корочку. Дровяная печь: используется для пиццы (450°C), хлеба, запечённой рыбы. Открытый мангал: наиболее «первобытный» формат — виден в зале, создаёт атмосферу. Очаг/камин: больше декоративная функция, иногда готовят фондю.",
        "list": [
          "Хоспер: угольный гриль для мяса и рыбы",
          "Дровяная печь: пицца, хлеб, запечённые блюда",
          "Открытый мангал: атмосфера и дым",
          "Камин: декоративный элемент, иногда кулинарный"
        ]
      },
      {
        "heading": "Хоспер в «Парусах»",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) готовит мясные блюда на хоспере. Угольный гриль даёт стейкам и рыбе тот самый дымный вкус, который невозможно получить на обычной плите. В сочетании с видом на Петербург — полноценный гастрономический опыт. Читайте о <a href='/blog/restorany-s-khosperom-spb' class='underline text-accent'>ресторанах с хоспером в СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин с мясом на хоспере", "href": "/menu" }
  },
  {
    "slug": "restorany-sredizemnomorskaya-kukhnya-spb",
    "title": "Рестораны со средиземноморской кухней в СПб",
    "metaTitle": "Рестораны средиземноморская кухня СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны со средиземноморской кухней в Санкт-Петербурге: Италия, Греция, Испания на тарелке.",
    "keywords": "рестораны средиземноморская кухня спб, средиземноморская кухня ресторан петербург, греческая испанская кухня спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Средиземноморская кухня — оливковое масло, свежие морепродукты, овощи, зелень, лёгкие соусы. В Петербурге это летняя кухня, которая ощущается особенно свежей после долгой зимы.",
    "sections": [
      {
        "heading": "Принципы средиземноморской кухни",
        "body": "Основа: оливковое масло первого отжима — не сливочное масло и не растительное. Морепродукты: рыба, осьминог, кальмар, мидии, гребешки — свежие, не замороженные. Овощи: помидоры, баклажаны, цукини, болгарский перец — обязательны. Зелень: базилик, орегано, петрушка, лимон. Сыры: фета, моцарелла, пармезан. Всё это легко, ярко, солнечно.",
        "list": [
          "Оливковое масло: основа всего",
          "Морепродукты: свежие — главный ингредиент",
          "Помидоры: Сан-Марцано или черри — обязательно",
          "Зелень и лимон: кислотный баланс"
        ]
      },
      {
        "heading": "Средиземноморские элементы в «Парусах»",
        "body": "Меню «Парусов» (ул. Марата, 5) включает блюда с выраженным средиземноморским характером: морепродукты, карпаччо, авторские закуски с оливковым маслом. Авторская кухня сочетает петербургские продукты с итальянскими и испанскими техниками. Рейтинг 5,0. Читайте <a href='/menu' class='underline text-accent'>меню</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "restorany-ekonomnyy-uzhin-peterburg",
    "title": "Рестораны для экономного ужина в Петербурге",
    "metaTitle": "Рестораны для экономного ужина Петербург 2026 | Паруса",
    "metaDescription": "Где поужинать экономно в Санкт-Петербурге: рестораны с ценами до 1000 рублей в центре.",
    "keywords": "рестораны экономный ужин петербург, дешёвый ужин ресторан спб, где поужинать дёшево петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Экономный ужин в ресторане — это не столовая. Это разумный выбор формата и времени. Расскажем, как хорошо поужинать в центре Петербурга, не потратив лишнего.",
    "sections": [
      {
        "heading": "Стратегия экономного ужина",
        "body": "Ужинайте в будни: рестораны менее загружены, некоторые предлагают вечерние специальные цены. Выбирайте рестораны с бизнес-ланчем (до 16:00) как «ранний ужин». Ищите рестораны с хорошим соотношением цена/качество на Марата, Загородном, Рубинштейна — не на Невском. Средний чек 900–1 200 ₽ за человека с напитком — реалистичная цель.",
        "list": [
          "Будни: часто дешевле",
          "Ранний ужин (до 17:00): иногда есть ланч-цены",
          "Боковые улицы от Невского: 20–30% дешевле",
          "Улица Марата: лучшее соотношение цена/качество"
        ]
      },
      {
        "heading": "Экономный ужин с видом",
        "body": "«Паруса на крыше» (ул. Марата, 5) — ужин от 700–900 ₽ (без алкоголя, блюдо + напиток). Средний чек с вином — около 1 300 ₽. Для Петербурга и такого вида — это честная цена. Рейтинг 5,0. Бизнес-ланч от 590 ₽ (только будни). Читайте о <a href='/blog/nedorogie-restorany-tsentr-peterburg' class='underline text-accent'>недорогих ресторанах центра</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-bluda-do-1000-rubley-tsentr-spb",
    "title": "Рестораны с блюдами до 1000 рублей в центре СПб",
    "metaTitle": "Рестораны с блюдами до 1000 рублей центр СПб 2026 | Паруса",
    "metaDescription": "Где поесть в центре Петербурга с блюдами до 1000 рублей: рестораны с разумными ценами.",
    "keywords": "рестораны блюда до 1000 рублей спб, ресторан до 1000 рублей центр петербург, дешёвые блюда ресторан спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Блюда до 1 000 ₽ в ресторане центра Петербурга — реальность. Особенно если речь о бизнес-ланче или умно выбранных позициях в меню.",
    "sections": [
      {
        "heading": "Как найти блюда до 1000 рублей",
        "body": "Ищите рестораны с бизнес-ланчем: набор за 500–800 ₽ — это реальное горячее за честную цену. В обычном меню: паста, супы, лёгкие закуски — часто в диапазоне 400–900 ₽. Стейки и рыба на хоспере — обычно выше 1 000 ₽. Избегайте туристических мест у Невского: там блюдо за 1 000 ₽ — это «минимум».",
        "list": [
          "Бизнес-ланч: лучшая цена за горячее",
          "Паста и салаты: часто до 700–900 ₽",
          "Супы: 350–600 ₽",
          "Туристические места: дороже аналогов в переулках"
        ]
      },
      {
        "heading": "«Паруса» и ценовой диапазон",
        "body": "В меню «Парусов» (ул. Марата, 5) есть позиции до 1 000 ₽ — закуски, лёгкие горячие. Бизнес-ланч от 590 ₽ — в будни. Средний чек ужина 1 300 ₽ с напитками. Это «выше среднего», но с видом, который сложно переоценить. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "luchshie-novye-restorany-peterburg-2026",
    "title": "Лучшие новые рестораны Петербурга 2026: что открылось",
    "metaTitle": "Лучшие новые рестораны Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Обзор лучших новых ресторанов Санкт-Петербурга 2026: что открылось и стоит посетить.",
    "keywords": "новые рестораны петербург 2026, открылись рестораны спб, новые рестораны спб 2026",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "В Петербурге ежегодно открываются десятки новых ресторанов. Но лучший «новый» — не всегда лучший. Расскажем, как выбирать среди открытий.",
    "sections": [
      {
        "heading": "Почему «новый» не всегда значит «лучший»",
        "body": "Новый ресторан — это всегда эксперимент. Первые 3–6 месяцев — «обкатка»: текут технологии, обучается персонал. Рейтинги новых ресторанов ненадёжны — мало отзывов, и они часто написаны «заряженными» гостями или блогерами по приглашению. Ресторан, проработавший 3+ года с высоким рейтингом — гораздо более надёжная ставка.",
        "list": [
          "Первые 3–6 месяцев: обкатка, не лучшее время",
          "Мало отзывов: статистически ненадёжно",
          "Рекламные посты: отличаются от реальных оценок",
          "Проверенные рестораны: надёжнее новых"
        ]
      },
      {
        "heading": "Проверенный vs новый",
        "body": "«Паруса на крыше» (ул. Марата, 5) — проверенный временем. С 2009 года, рейтинг 5,0 при 2 606 реальных отзывах. Это не «новый хайп» — это стабильное качество, которое доказано 15 годами работы. При прочих равных: надёжность важнее новизны. Но если хочется новинок — следите за отзывами на Яндекс через 6 месяцев после открытия."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-shef-povar-peterburg",
    "title": "Рестораны где готовит шеф-повар в Петербурге",
    "metaTitle": "Рестораны с шеф-поваром Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с авторским шефом в Санкт-Петербурге: где кухня — это личный взгляд на еду.",
    "keywords": "рестораны шеф повар петербург, рестораны авторского шефа спб, шеф повар ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "«Ресторан с шефом» — не просто место, где есть повар. Это место, где кухня — это авторский взгляд конкретного человека. Такие рестораны узнаются по обновляющемуся меню и особой последовательности вкусов.",
    "sections": [
      {
        "heading": "Что значит «авторский шеф»",
        "body": "Авторский шеф: создаёт меню самостоятельно, а не по стандартным рецептам. Обновляет карту сезонно. Выбирает поставщиков лично. Присутствует на кухне в пиковые дни. Иногда выходит в зал. Признак: меню меняется, и гости, которые приходят несколько раз, каждый раз обнаруживают что-то новое.",
        "list": [
          "Авторское меню: меняется сезонно",
          "Личный выбор продуктов: качество первично",
          "Присутствие на кухне: не управление по телефону",
          "Гости приходят снова: ради нового меню"
        ]
      },
      {
        "heading": "Авторская кухня «Парусов»",
        "body": "«Паруса на крыше» (ул. Марата, 5) работают в формате авторской кухни. Меню обновляется сезонно. 15+ лет стабильного рейтинга 5,0 — показатель системной работы с качеством. Читайте о <a href='/blog/avtorskaya-kukhnya-peterburg-trendy' class='underline text-accent'>авторской кухне Петербурга</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "restorany-kamernaya-atmosfera-peterburg",
    "title": "Рестораны с камерной атмосферой в Петербурге",
    "metaTitle": "Рестораны с камерной атмосферой Петербург 2026 | Паруса",
    "metaDescription": "Рестораны с тихой, камерной атмосферой в Санкт-Петербурге: для важных разговоров и особых вечеров.",
    "keywords": "рестораны камерная атмосфера петербург, тихие рестораны спб, камерный ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Камерный ресторан — место, где можно говорить вполголоса, и вас услышат только за своим столом. В Петербурге такие места есть — и они особенно ценны для важных деловых встреч и интимных ужинов.",
    "sections": [
      {
        "heading": "Что создаёт камерность",
        "body": "Небольшой зал (20–40 мест). Ниши или перегородки между столиками. Приглушённый свет. Уровень шума: не более 60–65 дБ (спокойный разговор). Расстояние между столами: не менее метра. Хорошая акустика: правильные материалы поглощают звук. Все эти факторы вместе создают ощущение «своего» пространства.",
        "list": [
          "Небольшой зал: 20–40 мест — идеально",
          "Перегородки или ниши: физическое разделение",
          "Приглушённый свет: важен психологически",
          "Расстояние между столами: метр — минимум"
        ]
      },
      {
        "heading": "Камерность в «Парусах»",
        "body": "Зал «Парусов» (ул. Марата, 5) — большой (до 300 гостей для банкета), но с зонированием. Для камерного ужина запросите столик в спокойной зоне при бронировании. Вечерние будни — наиболее спокойный вариант. Рейтинг 5,0. Для деловых встреч: тихие будни + приватная зона. Читайте о <a href='/blog/restoran-dlya-delovoy-vstrechi-spb' class='underline text-accent'>деловых встречах в ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать тихий столик", "href": "/" }
  },
  {
    "slug": "restorany-peterburg-kuda-vozvrashchatsya",
    "title": "Рестораны Петербурга, куда стоит возвращаться",
    "metaTitle": "Рестораны Петербурга куда возвращаться 2026 | Паруса на крыше",
    "metaDescription": "Какие рестораны Санкт-Петербурга заслуживают повторного визита: признаки хорошего заведения.",
    "keywords": "рестораны петербург куда возвращаться, лучшие рестораны спб постоянные гости, рестораны петербург постоянные посетители",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Лучший показатель ресторана — не рейтинг на сайте, а желание вернуться. Разберём, что делает ресторан «своим» и почему «Паруса» — один из таких мест.",
    "sections": [
      {
        "heading": "Что делает ресторан «своим»",
        "body": "Несколько факторов: персонал помнит вас (или делает вид — оба варианта приятны). Меню меняется — есть причина прийти снова и попробовать новое. Атмосфера предсказуемо хорошая — вы знаете, что не разочаруетесь. Цена соответствует ценности — «дорого» само по себе не означает «не возвращаться».",
        "list": [
          "Персонал: узнают или искренне рады",
          "Меню обновляется: причина прийти снова",
          "Стабильность: предсказуемо хорошо",
          "Цена: честна по отношению к ценности"
        ]
      },
      {
        "heading": "«Паруса» как «свой» ресторан",
        "body": "2 606 отзывов с рейтингом 5,0 — это во многом постоянные гости. Ресторан работает с 2009 года именно благодаря тем, кто возвращается — на дни рождения, по особым поводам, на корпоративы. Авторская кухня с сезонными обновлениями даёт причину прийти снова. «Хорошее место 2026» по версии Яндекса."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-s-khoroshimi-otzyvami-2gis",
    "title": "Рестораны СПб с хорошими отзывами на 2ГИС",
    "metaTitle": "Рестораны СПб с хорошими отзывами на 2ГИС 2026 | Паруса",
    "metaDescription": "Рестораны Санкт-Петербурга с высокими оценками на 2ГИС: как читать рейтинги и выбирать.",
    "keywords": "рестораны спб хорошие отзывы 2гис, рейтинг рестораны 2гис петербург, 2гис рестораны спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "2ГИС — популярный сервис с картами и отзывами. Как использовать его для выбора ресторана в Петербурге?",
    "sections": [
      {
        "heading": "Как читать рейтинги 2ГИС",
        "body": "2ГИС собирает реальные отзывы. Алгоритм схож с Яндексом: высокий рейтинг при большом количестве отзывов = надёжный показатель. Фильтры: можно фильтровать по кухне, цене, времени работы. Фото от гостей: важный индикатор реального вида и блюд. Минус: некоторые рестораны накручивают отзывы — проверяйте на нескольких платформах.",
        "list": [
          "Рейтинг + количество отзывов: пара показателей",
          "Фото от гостей: честнее официальных",
          "Последние отзывы: отражают актуальное состояние",
          "Сравнение с Яндексом: перекрёстная проверка"
        ]
      },
      {
        "heading": "«Паруса» на 2ГИС",
        "body": "«Паруса на крыше» присутствуют на 2ГИС с высоким рейтингом. Ищите по адресу: ул. Марата, 5. Рейтинг на Яндекс Картах 5,0 при 2 606 отзывах — ориентир. Для полноты картины читайте отзывы на обеих платформах."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "letnyaya-terrasa-vstrecha-belykh-nochey",
    "title": "Рестораны для встречи белых ночей в Петербурге",
    "metaTitle": "Рестораны для встречи белых ночей Петербург 2026 | Паруса",
    "metaDescription": "Где встретить белые ночи с едой в Санкт-Петербурге: рестораны с верандой и панорамой.",
    "keywords": "рестораны встреча белых ночей петербург, белые ночи ресторан спб, рестораны белые ночи петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Белые ночи — самое романтичное время в Петербурге. Ужин при полночном свете — уникальный опыт, который невозможно повторить нигде южнее.",
    "sections": [
      {
        "heading": "Белые ночи: когда и что происходит",
        "body": "Период белых ночей: примерно 25 мая–15 июля. Солнце не заходит полностью: небо светло-синее всю ночь. Разводные мосты: с 01:15 при светлом небе. Ужин в 22:00 — за окном дневной свет. Это невозможно нигде, кроме северных широт. Петербург — самый южный город мира с такими ночами.",
        "list": [
          "25 мая–15 июля: основной период",
          "В 23:00 за окном: светло как днём",
          "Разводные мосты: при светлом небе — уникально",
          "Ужин в полночь: при дневном свете"
        ]
      },
      {
        "heading": "Терраса «Парусов» в белые ночи",
        "body": "Открытая терраса «Парусов» (ул. Марата, 5, 6 этаж) работает летом. В белые ночи — ужин под открытым небом с видом на светящийся горизонт. Казанский собор, крыши, небо без темноты. Это особое петербургское ощущение. Бронируйте заранее — июнь разбирают быстро. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать стол на открытой террасе", "href": "/terrasa" }
  },
  {
    "slug": "restoran-8-marta-spb",
    "title": "Рестораны на 8 марта в Петербурге: где отметить",
    "metaTitle": "Рестораны на 8 марта в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Где отметить 8 марта в ресторане Санкт-Петербурга: специальные меню, бронирование, форматы.",
    "keywords": "рестораны на 8 марта петербург, 8 марта ресторан спб, где отметить 8 марта петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "8 марта — один из самых «ресторанных» дней в году. В Петербурге в этот день рестораны заняты почти полностью. Как правильно спланировать и выбрать место?",
    "sections": [
      {
        "heading": "Как планировать 8 марта в ресторане",
        "body": "Бронируйте за 2–4 недели. Лучшие рестораны центра заполняются к 1–2 марта. Варианты: праздничный ужин 8-го, деловой обед 7-го (тише), романтический ужин вдвоём в спокойный день недели. Форматы: банкет для женского коллектива, романтический ужин для пары, семейный обед.",
        "list": [
          "Бронируйте за 2–4 недели",
          "7 марта: тише, чем 8-е",
          "Форматы: пара, семья, коллектив",
          "Специальное меню: уточняйте при бронировании"
        ]
      },
      {
        "heading": "«Паруса» на 8 марта",
        "body": "«Паруса на крыше» (ул. Марата, 5) — одно из лучших мест для 8 марта: вид на весенний Петербург, авторская кухня, живая музыка. Скидка 20% на счёт именинницы (если дата рождения совпадает с этим периодом). Телефон: +7 (812) 991-10-90. Читайте о <a href='/blog/restorany-8-marta-peterburg' class='underline text-accent'>праздновании 8 марта</a>."
      }
    ],
    "cta": { "text": "Забронировать на 8 марта", "href": "/" }
  },
  {
    "slug": "restorany-sezonnoe-menyu-vesna-spb",
    "title": "Рестораны с сезонным меню весной в Петербурге",
    "metaTitle": "Рестораны с сезонным меню весной СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с весенним сезонным меню в Петербурге: корюшка, первые овощи, весенние блюда.",
    "keywords": "рестораны сезонное меню весна петербург, весеннее меню ресторан спб, корюшка ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Весна в Петербурге — это корюшка. Маленькая рыбка с запахом огурца, которая заходит в Неву в апреле–мае, стала символом петербургской весны.",
    "sections": [
      {
        "heading": "Весенние деликатесы Петербурга",
        "body": "Корюшка (апрель–май): главный весенний деликатес. Жарится в муке на масле, пахнет огурцом — ни с чем не спутать. Первые огородные травы: черемша, крапива, первый зелёный горошек. Молодые ягнята: весенний сезон фермерского мяса. Сморчки: весенние грибы — появляются в апреле. Белая спаржа: середина весны.",
        "list": [
          "Корюшка: апрель–май, обязательно попробовать",
          "Черемша: первая зелень, острая и ароматная",
          "Сморчки: весенние грибы из Ленобласти",
          "Ягнятина: весенний сезон молодого мяса"
        ]
      },
      {
        "heading": "Сезонное меню «Парусов»",
        "body": "«Паруса» (ул. Марата, 5) обновляют меню сезонно — в том числе весной. Корюшка в сезон — обязательная позиция, которую стоит заказать. Авторская кухня с локальными продуктами Северо-Запада. Рейтинг 5,0. Уточняйте актуальное весеннее меню: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Посмотреть сезонное меню", "href": "/menu" }
  },
  {
    "slug": "restorany-romanticheskie-leto-peterburg",
    "title": "Рестораны для романтического ужина летом в Петербурге",
    "metaTitle": "Романтические рестораны летом Петербург 2026 | Паруса",
    "metaDescription": "Лучшие рестораны для романтического ужина летом в Санкт-Петербурге: открытые веранды, белые ночи.",
    "keywords": "романтический ужин лето петербург, рестораны летом романтика спб, романтика белые ночи ресторан",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Романтический ужин летом в Петербурге — это отдельный тип переживания. Белые ночи, тепло, открытые террасы. Особая атмосфера, которой не бывает в другое время года.",
    "sections": [
      {
        "heading": "Что делает летний романтический ужин особенным",
        "body": "Белые ночи: ужин в 22:00 при дневном свете — нереальное ощущение. Открытые террасы: воздух, ветер, небо. Тепло: нет пальто, нет спешки. Длинный вечер: можно начать в 19:00 и сидеть за столиком до 23:00 — за окном ещё светло.",
        "list": [
          "Белые ночи: дневной свет в 22:00",
          "Открытая терраса: воздух и небо",
          "Длинный вечер: 5–6 часов светлого времени",
          "Тепло: расслабленная, лёгкая атмосфера"
        ]
      },
      {
        "heading": "Летний романтик в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) летом — это открытая терраса с видом на белые ночи. Ужин под открытым небом, купол Казанского собора в горизонте, светлое небо в полночь. Это петербургское уникальное. Бронируйте заранее — летние выходные разбирают за 2 недели. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать летний романтический ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "restoran-paskhalnoye-menyu-peterburg",
    "title": "Рестораны с пасхальным меню в Петербурге",
    "metaTitle": "Пасхальное меню ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с пасхальным меню в Санкт-Петербурге: где отметить Пасху за праздничным столом.",
    "keywords": "пасхальное меню ресторан петербург, пасха ресторан спб, где отметить пасху ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Пасха — весенний праздник с богатыми гастрономическими традициями. Куличи, пасхи, крашеные яйца, ягнятина — в ресторанах Петербурга это время для особого меню.",
    "sections": [
      {
        "heading": "Пасхальное меню в ресторане",
        "body": "Хороший ресторан к Пасхе предложит: фирменный кулич или пасху в качестве сезонного десерта, ягнятину как основное блюдо (традиционный пасхальный символ), блюда из яиц в авторской интерпретации, весенние продукты — редис, первый горошек, черемша.",
        "list": [
          "Кулич или пасха: сезонный десерт",
          "Ягнятина: пасхальная традиция",
          "Авторские блюда из яиц",
          "Весенние продукты сезона"
        ]
      },
      {
        "heading": "Пасха в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) обновляют меню к праздникам. Уточняйте пасхальное меню при бронировании: +7 (812) 991-10-90. Весенний Петербург с 6-го этажа — купола в свете апрельского солнца — особенный вид для пасхального ужина. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать пасхальный ужин", "href": "/" }
  },
  {
    "slug": "restorany-zimnee-uyutnaya-atmosfera-spb",
    "title": "Рестораны с тёплым интерьером зимой в СПб",
    "metaTitle": "Рестораны с тёплым интерьером зимой СПб 2026 | Паруса",
    "metaDescription": "Самые уютные рестораны с тёплой атмосферой зимой в Санкт-Петербурге: свечи, камин, живая музыка.",
    "keywords": "рестораны тёплый интерьер зима спб, уютные рестораны зимой петербург, камерные рестораны зима петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Зимний Петербург — холодный, тёмный, серый. И именно поэтому рестораны зимой здесь особенные: тепло изнутри против холода снаружи. Уют становится главной ценностью.",
    "sections": [
      {
        "heading": "Что делает ресторан уютным зимой",
        "body": "Тёплый свет: свечи, абажуры, приглушённые тёплые лампочки. Живой огонь: камин (даже декоративный) создаёт атмосферу. Плотные текстуры: деревянные панели, тяжёлые шторы, мягкие сиденья. Горячие напитки в меню: глинтвейн, горячий сидр, согревающие коктейли. Живая музыка: создаёт звуковую теплоту.",
        "list": [
          "Тёплый свет: свечи и абажуры",
          "Живой огонь: камин или хоспер",
          "Тёплые напитки: глинтвейн, горячий шоколад",
          "Живая музыка: звуковое тепло"
        ]
      },
      {
        "heading": "«Паруса» зимой: уют с панорамой",
        "body": "Зимой «Паруса» (ул. Марата, 5, 6 этаж) — особенно атмосферны. Тёплый зал, огни ночного Петербурга за панорамными окнами, снежные крыши, подсветка куполов в декабрьских сумерках. Закат в 15:30 — обед превращается в закатный ужин. Живая музыка по расписанию. Рейтинг 5,0. Читайте о <a href='/blog/zimniy-restoran-uyutnyy-peterburg' class='underline text-accent'>зимних уютных ресторанах</a>."
      }
    ],
    "cta": { "text": "Забронировать зимний уютный ужин", "href": "/" }
  },
  {
    "slug": "restorany-na-novyy-god-peterburg",
    "title": "Рестораны на Новый год в Петербурге: где отметить",
    "metaTitle": "Рестораны на Новый год в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Где отметить Новый год в ресторане Санкт-Петербурга: специальные программы, цены, бронирование.",
    "keywords": "рестораны новый год петербург, новый год ресторан спб, где отметить новый год петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Новый год в ресторане — одна из самых популярных форм празднования. В Петербурге рестораны расписаны на 31 декабря за 2–3 месяца. Как найти место?",
    "sections": [
      {
        "heading": "Как планировать Новый год в ресторане",
        "body": "Бронируйте в октябре-ноябре — хорошие рестораны центра заполняются именно тогда. Форматы: новогодняя программа (ведущий, шоу, живая музыка) — более дорогой и насыщенный вариант. Просто хороший ужин в ночь с 31 на 1 — тише, без обязательной программы. Выбирайте под компанию: большие шумные корпоративы или камерный семейный ужин.",
        "list": [
          "Бронируйте в октябре-ноябре",
          "Программа vs просто ужин: выбирайте под компанию",
          "Шампанское в 00:00: уточните включено ли",
          "Нарядная одежда: как правило принята"
        ]
      },
      {
        "heading": "«Паруса» на Новый год",
        "body": "«Паруса» (ул. Марата, 5) — одно из лучших мест для Нового года: вид на зимний Петербург с 6-го этажа, живая музыка, авторская кухня. Иллюминация за окнами, шампанское в полночь, панорама заснеженного города. Читайте о <a href='/blog/novogodnyy-banket-restoran-peterburg' class='underline text-accent'>новогоднем банкете в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать Новый год", "href": "/korporativ" }
  },
  {
    "slug": "restorany-s-vidom-razvodnie-mosty-spb",
    "title": "Рестораны с видом на разводные мосты в СПб",
    "metaTitle": "Рестораны с видом на разводные мосты СПб 2026 | Паруса",
    "metaDescription": "Рестораны с видом на разводные мосты в Санкт-Петербурге: где посмотреть разводку мостов с ужином.",
    "keywords": "рестораны вид разводные мосты спб, вид на разводку мостов ресторан, ресторан мосты петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Разводные мосты Петербурга — одно из главных городских шоу. Апрель–ноябрь, с 01:15 до 04:30 — мосты разводятся. Посмотреть это с ужином — особый формат ночного Петербурга.",
    "sections": [
      {
        "heading": "Разводные мосты: факты",
        "body": "Основные разводные мосты: Дворцовый (01:10–02:55 и 03:10–04:55 — первым разводится и последним сводится), Троицкий, Литейный, Биржевой. Сезон: апрель–ноябрь. В белые ночи (июнь–июль): разводятся при светлом небе. Лучшие точки: набережная у Зимнего дворца, Биржевой мост, набережная Невы.",
        "list": [
          "Дворцовый: 01:10–04:55 — первым разводится",
          "Сезон: апрель–ноябрь",
          "Белые ночи: разводка при светлом небе — уникально",
          "Лучшая точка: набережная Невы у Зимнего"
        ]
      },
      {
        "heading": "Ужин перед разводкой в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) — правильный старт ночи разводных мостов. Ужин с 21:00 до 23:30 → прогулка к Неве (20 минут пешком) → разводка в 01:15. Полная программа петербургской ночи. Рейтинг 5,0. Читайте о <a href='/blog/nochnoy-peterburg-chto-posmotret' class='underline text-accent'>ночном Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин перед разводкой", "href": "/" }
  },
  {
    "slug": "luchshiy-restoran-pered-progulkoy-peterburg",
    "title": "Лучший ресторан перед прогулкой по Петербургу",
    "metaTitle": "Ресторан перед прогулкой по Петербургу 2026 | Паруса",
    "metaDescription": "Где пообедать или позавтракать перед прогулкой по Санкт-Петербургу: рестораны у начала маршрута.",
    "keywords": "ресторан перед прогулкой петербург, обед перед прогулкой спб, где поесть перед прогулкой петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Правильный обед или завтрак перед прогулкой по Петербургу — важная логистическая деталь. Как выбрать место, которое зарядит энергией и не будет слишком тяжёлым?",
    "sections": [
      {
        "heading": "Что есть перед долгой прогулкой",
        "body": "Баланс: достаточно сытно, чтобы хватило на 3–4 часа, но не настолько тяжело, чтобы хотелось спать. Хорошие варианты: суп + лёгкое горячее, паста, рыбное блюдо. Избегайте: очень жирных блюд, больших стейков, слишком много алкоголя перед прогулкой.",
        "list": [
          "Суп + лёгкое горячее: оптимально",
          "Паста: даёт медленную энергию",
          "Избегайте жирного перед активным днём",
          "Кофе: взбодрит, но не переусердствуйте"
        ]
      },
      {
        "heading": "«Паруса» как старт прогулки",
        "body": "Завтрак или обед в «Парусах» (ул. Марата, 5) — хорошее начало дня в Петербурге. С 6-го этажа вы сразу видите маршрут: Казанский собор, набережная, Невский — всё рядом. Бизнес-ланч от 590 ₽ в будни. Спуститесь с 6-го этажа и начните прогулку — вы уже в центре. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать завтрак", "href": "/" }
  },
  {
    "slug": "restorany-dlya-bolshoy-kompanii-peterburg",
    "title": "Рестораны для большой компании в Петербурге",
    "metaTitle": "Рестораны для большой компании Петербург 2026 | Паруса",
    "metaDescription": "Рестораны для большой компании в Санкт-Петербурге: от 20 до 100 человек, банкетные залы, цены.",
    "keywords": "рестораны для большой компании петербург, ресторан на 20 30 50 человек спб, рестораны компании петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Ресторан для большой компании — особый запрос. 20, 30, 50, 100 человек — каждая цифра требует своего подхода к выбору.",
    "sections": [
      {
        "heading": "Вместимость и форматы",
        "body": "До 20 человек: приватная зона или выделенный стол — большинство ресторанов справятся. 20–50 человек: нужен банкетный зал или выкуп части ресторана. 50–100 человек: полноценный банкетный зал обязателен. 100+: ресторан с залом от 150 м². Важно: не только вместимость, но и качество кухни при таком количестве гостей.",
        "list": [
          "До 20: приватная зона в большинстве ресторанов",
          "20–50: банкетный зал или часть ресторана",
          "50–100: нужен специализированный банкетный зал",
          "100+: крупные рестораны с залом от 150 м²"
        ]
      },
      {
        "heading": "«Паруса» для большой компании",
        "body": "«Паруса» (ул. Марата, 5) — один из немногих ресторанов центра Петербурга, способных принять до 300 гостей. Банкетное меню от 2 500 ₽/чел, менеджер мероприятий, живая музыка. Для мероприятий на 20–300 человек — звоните: +7 (812) 991-10-90. Читайте о <a href='/banket' class='underline text-accent'>банкетных возможностях</a>."
      }
    ],
    "cta": { "text": "Забронировать для большой компании", "href": "/banket" }
  },
  {
    "slug": "restorany-dlya-devichnika-top-spb",
    "title": "Лучшие рестораны для девичника в СПб: топ 2026",
    "metaTitle": "Лучшие рестораны для девичника СПб 2026 | Паруса на крыше",
    "metaDescription": "Топ ресторанов для девичника в Санкт-Петербурге: красиво, вкусно, атмосферно для подруг невесты.",
    "keywords": "лучшие рестораны девичник спб, ресторан девичник петербург топ, девичник ресторан 2026 спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Девичник — один из самых красивых поводов для похода в ресторан. Место должно быть особенным: красивым для фото, с хорошей едой и правильной атмосферой.",
    "sections": [
      {
        "heading": "Что нужно для девичника в ресторане",
        "body": "Красивый вид для фото (обязательно!). Возможность выделенной зоны для компании. Дегустация вин или коктейлей как формат. Живая музыка или музыкальная программа. Декор и оформление по запросу. В «Парусах» (ул. Марата, 5) все эти элементы доступны — вид с 6-го этажа производит впечатление на фото и в реальности.",
        "list": [
          "Вид: фотогеничный и живописный",
          "Приватная зона: для компании 6–20 человек",
          "Дегустация вин: стильно и вовлекает всех",
          "Живая музыка: по расписанию или по заказу"
        ]
      },
      {
        "heading": "«Паруса» для девичника",
        "body": "Скидка 20% для виновницы торжества. Приватная зона по запросу. Вид на Петербург создаёт идеальный фон для фотосессии. Рейтинг 5,0. Читайте о <a href='/blog/devichnik-na-kryshe-peterburg' class='underline text-accent'>девичнике на крыше</a>."
      }
    ],
    "cta": { "text": "Забронировать девичник", "href": "/banket" }
  },
  {
    "slug": "top-restorany-privatnye-zaly-spb",
    "title": "Топ ресторанов с приватными залами в СПб",
    "metaTitle": "Рестораны с приватными залами СПб топ 2026 | Паруса",
    "metaDescription": "Топ ресторанов с приватными залами в Санкт-Петербурге: для мероприятий и деловых встреч.",
    "keywords": "рестораны приватные залы спб, ресторан приватный зал петербург, переговорная комната ресторан спб",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Приватный зал в ресторане — незаменимый инструмент для деловых встреч, семейных торжеств и закрытых мероприятий. Разберём, что искать.",
    "sections": [
      {
        "heading": "Что такое приватный зал",
        "body": "Приватный зал — отдельное помещение, полностью изолированное от общего зала. Не просто «отгороженный столик», а закрытая дверь. Для деловых переговоров — конфиденциальность. Для семейного торжества — уединённость. Дополнительно может включать: проектор, экран, микрофон, отдельный вход.",
        "list": [
          "Отдельная комната: не просто ширма",
          "Проектор и экран: для деловых встреч",
          "Отдельный вход: для особой приватности",
          "Стоимость: обычно депозит или минимальный чек"
        ]
      },
      {
        "heading": "Приватные зоны в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) предлагают приватные зоны для мероприятий. Для банкетов до 300 гостей — весь зал. Для деловых ужинов — выделенная зона. Уточняйте при бронировании: +7 (812) 991-10-90. Рейтинг 5,0. Читайте о <a href='/banket' class='underline text-accent'>банкетных возможностях</a>."
      }
    ],
    "cta": { "text": "Забронировать приватный зал", "href": "/banket" }
  },
  {
    "slug": "luchshie-restorany-dlya-svadby-spb",
    "title": "Лучшие рестораны для свадьбы в Петербурге",
    "metaTitle": "Лучшие рестораны для свадьбы СПб 2026 | Паруса на крыше",
    "metaDescription": "Топ ресторанов для свадьбы в Санкт-Петербурге: большие залы, виды, банкетное меню, организация.",
    "keywords": "рестораны для свадьбы петербург топ, свадьба ресторан спб лучший, ресторан свадьба петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Выбор ресторана для свадьбы — одно из главных решений при планировании. Правильное место создаёт атмосферу, неправильное — разрушает её.",
    "sections": [
      {
        "heading": "Критерии свадебного ресторана",
        "body": "Вместимость: соответствует числу гостей плюс площадка для танцев (если планируется). Кухня: важна особенно — свадебный ужин должен быть вкусным. Вид или особое пространство: свадьба запоминается местом. Менеджер мероприятий: профессиональная координация. Опыт свадеб: ресторан, где проведено много свадеб, знает нюансы.",
        "list": [
          "Вместимость + место для танцев",
          "Кухня: свадьба — не место для экономии на еде",
          "Видовой или архитектурный вау-эффект",
          "Менеджер: профессиональная организация"
        ]
      },
      {
        "heading": "Свадьба в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5, 6 этаж) — проведены сотни свадеб с 2009 года. Зал до 300 гостей, панорама Петербурга, банкетное меню от 2 500 ₽/чел. Для свадьбы звоните: +7 (812) 991-10-90. Читайте о <a href='/svadba' class='underline text-accent'>свадебных возможностях ресторана</a>."
      }
    ],
    "cta": { "text": "Узнать о свадьбе в «Парусах»", "href": "/svadba" }
  },
  {
    "slug": "restorany-dlya-delovoy-vstrechi-spb",
    "title": "Рестораны для деловой встречи в Петербурге",
    "metaTitle": "Рестораны для деловой встречи Петербург 2026 | Паруса",
    "metaDescription": "Лучшие рестораны для деловой встречи в Санкт-Петербурге: тишина, приватность, достойный уровень.",
    "keywords": "рестораны деловая встреча петербург, ресторан для переговоров спб, деловая встреча ресторан петербург",
    "date": "2026-06-08",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Деловая встреча в ресторане — классика. Но не каждый ресторан подходит. Тишина, приватность, правильный уровень — три ключевых критерия.",
    "sections": [
      {
        "heading": "Что нужно для деловой встречи",
        "body": "Тишина: разговор должен быть слышен. Уровень: ресторан говорит о вас. Не слишком дорогой (претенциозно), не слишком простой (неуважение к партнёру). Приватность: столик в стороне от основного зала. Сервис: профессиональный, не навязчивый — официант не подходит каждые 3 минуты.",
        "list": [
          "Тишина: слышать друг друга обязательно",
          "Уровень: средний или выше среднего",
          "Приватный столик: в стороне от шума",
          "Сервис: деловое обслуживание"
        ]
      },
      {
        "heading": "«Паруса» для деловых встреч",
        "body": "«Паруса» (ул. Марата, 5) — правильный выбор для деловых встреч: достаточно высокий уровень, но без пафоса. Вид на Петербург создаёт хороший «разговорный старт». Будни — наиболее тихие. Средний чек 1 300 ₽. Рейтинг 5,0. Читайте о <a href='/blog/delovoy-uzhin-restoran-peterburg' class='underline text-accent'>деловом ужине в ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать деловой обед", "href": "/" }
  }
];
